import { GraduationCap } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useTrainingModeStore } from '@/store/trainingMode';

/**
 * Persistent banner displayed at the top of the POS when Training Mode is active.
 * Amber/yellow color scheme to make it unmissable.
 * Contains a toggle for the guided tutorial.
 */
export function TrainingModeBanner() {
  const { isTrainingMode, isTutorialEnabled, toggleTutorial } = useTrainingModeStore();

  if (!isTrainingMode) return null;

  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-lg bg-amber-500/15 border border-amber-500/30 px-4 py-2.5">
      <div className="flex items-center gap-2.5">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-500/20">
          <GraduationCap className="h-4.5 w-4.5 text-amber-600 dark:text-amber-400" />
        </div>
        <div>
          <p className="text-sm font-semibold text-amber-700 dark:text-amber-300">
            Training Mode
          </p>
          <p className="text-xs text-amber-600/80 dark:text-amber-400/80">
            Sales and payments will not be recorded
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <label
          htmlFor="tutorial-toggle"
          className="text-xs font-medium text-amber-700 dark:text-amber-300 cursor-pointer select-none"
        >
          Enable tutorial
        </label>
        <Switch
          id="tutorial-toggle"
          checked={isTutorialEnabled}
          onCheckedChange={toggleTutorial}
          className="data-[state=checked]:bg-amber-500"
        />
      </div>
    </div>
  );
}
